// extracted by mini-css-extract-plugin
module.exports = {"section":"Withdraw_section__Rt6HU","input":"Withdraw_input__0PMW_"};